import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { StatusPercentageMap, SubTask } from 'app-models';
import { combineLatest, Subject } from 'rxjs';
import { PetitionerService } from 'src/app/services/petitioner.service';
import * as fromTask from '../../task-state/reducers/task.reducer';
import { takeUntil } from 'rxjs/operators';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-petition-status',
  templateUrl: './petition-status.component.html',
  styleUrls: ['./petition-status.component.scss']
})
export class PetitionStatusComponent implements OnInit, OnDestroy, AfterViewInit {
  selectedTaskTypeCode;
  selectedChartDataFlag: string;
  subTaskList: SubTask[];
  statusPercentageMap: StatusPercentageMap[];
  chartData;
  
  observableSubscription$ = new Subject();
  chartOption;
  constructor(private petitionerService: PetitionerService, private store: Store<fromTask.State>,
    private referenceLibraryService: ReferenceLibraryService
  ) { }

  ngOnInit(): void {

    combineLatest([
      this.store.select(fromTask.getSubTaskList),
      this.store.select(fromTask.getSuperTask)
    ])
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(([subTaskList, superTask]) => {
        if (subTaskList) {
          this.subTaskList = subTaskList;
          this.getStatusMap();
        }
      })
  }

  getStatusMap() {
    const data: any = {};
    const labels: any = [];
    const values: any = [];
    const backgroundColor = [
      '#e1e1e1',
      '#86d87f',
      '#01a0da'
    ];
    this.selectedChartDataFlag = 'Completed';
    this.subTaskList.forEach(element => {
      
        this.statusPercentageMap = element['statusPercentageMap'];
        if (this.statusPercentageMap !== undefined) {
          for (const prop in this.statusPercentageMap) {
            if (this.statusPercentageMap.hasOwnProperty(prop)) {
              labels.push(prop);
              values.push(this.statusPercentageMap[prop]);
            }
          }
          data.labels = labels;
          data.datasets = [];
          const set: any = {};
          set.data = values;
          set.backgroundColor = backgroundColor;
          data.datasets.push(set);
          this.chartData = data;
          this.chartOption = {
            cutoutPercentage: 95,
            legend: {
              position: 'right'
            }
          };
      }
    });
  }

  ngAfterViewInit() {
    this.translet();    
  }
  translet(){
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);  
  }

  ngOnDestroy(): void {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
